import React from 'react';
import { Container, Row, Col, Form, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { withLocale } from '@dietlabs/components';

export class NotificationsSettingsFormPlaceholder extends React.Component {
    render() {
        return (
            <Container
                id="settings-agreements"
                className={this.props.className}
            >
                <Row>
                    <Col xs="12" md={{ size: 8, offset: 2 }}>
                        <div className="white-box pt-2 pb-0">
                            <Form>
                                <h2 className="title-small semi-bold">
                                    {this.props.t('settings/notifications')}
                                </h2>
                                <p>
                                    {this.props.t(
                                        'settings/agreements/newsletter-info'
                                    )}
                                </p>
                                <Label>
                                    {this.props.t('settings/notifications')}
                                </Label>
                                <div className="form-switch">
                                    <Label className="form-switch-label">
                                        {this.props.t(
                                            'settings/agreements/diet-course'
                                        )}
                                    </Label>
                                </div>

                                <div className="form-switch">
                                    <Label className="form-switch-label">
                                        {this.props.t(
                                            'settings/agreements/newsletter'
                                        )}
                                    </Label>
                                </div>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

NotificationsSettingsFormPlaceholder.propTypes = {
    t: PropTypes.func.isRequired,
    className: PropTypes.string,
};

NotificationsSettingsFormPlaceholder.defaultProps = {
    className: null,
};

export default withLocale(NotificationsSettingsFormPlaceholder);
